import type { PaperWidth } from '@aeris/printing'

/**
 * The paper the printer at this counter is loaded with.
 *
 * Remembered per device, for the reason the till is: it is a property of the
 * machine and the printer beside it, not of whoever is standing there. A shop
 * with a 58mm roll at the counter and 80mm in the office wants both answers at
 * once, and per-user would give it one.
 *
 * 58mm is the default because it is the narrower of the two: a receipt laid
 * out for 80mm and printed on 58mm loses the right-hand column, which is where
 * every figure is. Guessing wrong in this direction merely wastes width.
 */

const STORAGE_KEY = 'aeris.receipt-paper'

export const readRememberedPaper = (): PaperWidth =>
  window.localStorage.getItem(STORAGE_KEY) === '48' ? 48 : 32

export const rememberPaper = (width: PaperWidth): void => {
  window.localStorage.setItem(STORAGE_KEY, String(width))
}
